import { Box } from '@mui/material';
import QRCode from 'react-qr-code';
import { styles } from './styles';

interface QRCodeComponentProps {
  url?: string;
}

const QRCodeComponent = ({ url }: QRCodeComponentProps) => {
  return (
    <Box sx={styles.container}>
      <QRCode value={url ?? ''} />
    </Box>
  );
};

export default QRCodeComponent;
